export function divide(first: number, second: number) {
  return first / second;
}

export function add(first: number, second: number) {
  return first + second;
}

export function multiply(first: number, second: number) {
  return first * second;
}

export function subtract(first: number, second: number) {
  return first - second;
}

export function modulus(first: number, second: number) {
  return first % second;
}

export function getDate(createdOn: any) {
  let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let day: any = new Date(createdOn).getDate();
  day = day < 10 ? '0' + day : day;
  let month = months[new Date(createdOn).getMonth()];
  let year = new Date(createdOn).getFullYear();
  return `${day} ${month}, ${year}`;
}

export function getDateTime(createdOn: any) {
  let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let day: any = new Date(createdOn).getDate();
  day = day < 10 ? '0' + day : day;
  let month = months[new Date(createdOn).getMonth()];
  let year = new Date(createdOn).getFullYear();

  let hours = new Date(createdOn).getHours();
  let minutes: any = new Date(createdOn).getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  let strTime = hours + ':' + minutes + ' ' + ampm;

  return `${day} ${month}, ${year} ${strTime}`;
}

export function getCurrency(value: string) {
  if (value) {
    return "₦" + value.toLocaleString();
  }
}

export function truncateString(str: string, length: number) {
  if (str.length > length) {
    let subStr = str.substring(0, length);
    return subStr + "...";
  } else {
    return str;
  }
}

export function colorGenerator() {
  const length = 6;
  const chars =
    '0123456789abcdef';
  let result = '';

  for (let i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return '#' + result + "bc";

}

// random string generator
export function requestIdGenerator() {
  const length = 32;
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';

  for (let i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

export function errorHandler(data: any) {
  data.validationMessages = data.validationMessages||[];
  let err =  data.validationMessages.length>0? data.validationMessages.join(","):data.message;
  return err;
}

const Functions = {
  divide,
  add,
  multiply,
  modulus,
  subtract,
  getDate,
  getDateTime,
  getCurrency,
  truncateString,
  colorGenerator,
  requestIdGenerator,
  errorHandler
};

export default Functions;